import { createFileRoute, redirect } from "@tanstack/react-router";

/**
 * SCRUM-231/229: la entrada "Ventas" abre el listado directo.
 * Conservamos /app/ordenes como alias → /app/pedidos (sin hub intermedio).
 */
export const Route = createFileRoute("/app/ordenes/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/pedidos" });
  },
  head: () => ({ meta: [{ title: "Ventas — Structura Market" }] }),
});
